import { Result } from '@otto-ec/eprivacy-measures'
import { LOAD_CB_LAZY_TOGGLE, type TrackingService } from './core'
import { initMeasureService } from './singletons'
import { __loadOneTrustSDK, __oneTrustSdkReady } from '@otto-ec/eprivacy-cmp'
import { hasConsentBeenGiven } from '@otto-ec/eprivacy-onetrust-sdk'

export const bootstrapLazy = async (trackingService: TrackingService) => {
  if (!hasConsentBeenGiven()) {
    await importBootstrapAndSignalCmpOnetrustReady(trackingService)
    return
  }

  await initMeasureService.startLoad()
  __loadOneTrustSDK.on(
    async () => {
      await importBootstrapAndSignalCmpOnetrustReady(trackingService)
    },
    { once: true }
  )
  /*                                                                  */
  setTimeout(
    () =>
      initMeasureService.endLoad(Result.CBHidden, {
        toggle: LOAD_CB_LAZY_TOGGLE,
      }),
    0
  )
}

async function importBootstrapAndSignalCmpOnetrustReady(
  trackingService: TrackingService
) {
  await (await import('./bootstrap')).bootstrap(trackingService)
  /*                                                                    */
  /*                                                               */
  __oneTrustSdkReady.emit({ retain: true })
}
